/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import { FullScreenLoading } from 'pg-ui-library';
import { IPage } from 'src/interfaces';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useLocalStorage } from 'src/hooks/useLocalStorage';
import jwt_decode from 'jwt-decode';

const Impersonation: React.FC<IPage> = () => {
  localStorage.clear();
  const [searchParams] = useSearchParams();
  const [token, setToken] = useLocalStorage('accessToken', null);
  const [modules, setModules] = useLocalStorage('modules', null);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const authToken = searchParams.get('token');
    const decodedToken: any = !authToken ? '' : jwt_decode(authToken);
    const authModules = decodedToken.modules;

    if (JSON.stringify(authModules) === JSON.stringify(modules)) {
      if (token) {
        navigate('/dashboard', { replace: true });
      }
    }
  }, [token]);

  useEffect(() => {
    try {
      setLoading(true);

      const authToken = searchParams.get('token');
      const decodedToken: any = !authToken ? '' : jwt_decode(authToken);
      const authModules = decodedToken.modules;

      if (!authToken || !decodedToken) {
        navigate('/login', { replace: true });
      } else {
        setToken(authToken);
        setModules(authModules);
      }
    } catch (err: any) {
      navigate('/login', { replace: true });
    }
  }, []);

  return <>{loading && <FullScreenLoading />}</>;
};

export default Impersonation;
